
<div class="row mb-2">
  <div class="col">
    <div class="float-right">
      <span class="mr-2 align-middle d-inline-flex align-items-center" *ngIf="!apenasAgendados"
            style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:6px 10px;gap:8px;">
        <small class="mb-0" style="font-weight:600;color:#475569;">PDV novo</small>
        <kendo-switch [(ngModel)]="usarTelaNovaPdv" (ngModelChange)="alterouUsarTelaNovaPdv($event)"
                      name="usarTelaNovaPdvAcompanhar" id="usarTelaNovaPdvAcompanhar"></kendo-switch>
      </span>

      <button class="btn btn-blue mr-2 waves-effect waves-light   btn-novo " (click)="vaParaNovoPedido(false)">
        Novo Pedido</button>

      <button class="btn btn-warning mr-2 waves-effect waves-light   btn-novo " *ngIf="!empresa.integracaoDelivery" (click)="vaParaNovoPedido(true)">
        Novo Pedido Balcão</button>

      <button type="button" class="btn btn-primary mr-2 waves-effect waves-light btn-novo"
              *ngIf="!apenasAgendados && producaoInternaAtiva()" (click)="exibirPedidoInterno = true">
        Pedido produzir</button>

      <button class="btn btn-danger waves-effect waves-light   btn-novo " (click)="abraModalFinalizar()">
        Finalizar Pedidos</button>
    </div>
  </div>
</div>

<app-pedido-interno *ngIf="exibirPedidoInterno" [empresa]="empresa" (fechou)="exibirPedidoInterno = false"
                    (criado)="criouPedidoInterno($event)"></app-pedido-interno>


<div class="row">
  <div class="col-6 col-lg-3">
    <div class="card-box ribbon-box  com-borda">
      <div class=" ribbon ribbon-dark float-left">
        <span>Total</span>
      </div>
       <h5 class="text-info float-right mt-0 total">
         {{resumoPedidos.total | number}}
       </h5>

      <div class="ribbon-content">
         <p></p>
      </div>

    </div>
  </div>
  <div class="col-6 col-lg-3">
    <div class="card-box ribbon-box ">
      <div class=" ribbon ribbon-warning float-left">
        <span>Em Preparação</span>
      </div>
      <div class="text-info float-right mt-0 total">
        {{resumoPedidos.emPreparacao | number}}
      </div>

      <div class="ribbon-content">
        <p></p>
      </div>

    </div>
  </div>
  <div class="col-6 col-lg-3">
    <div class="card-box ribbon-box  ">
      <div class=" ribbon ribbon-success float-left">
        <span>Em Entrega</span>
      </div>

      <div class="text-info float-right mt-0 total">
        {{resumoPedidos.emEntrega | number}}
      </div>

      <div class="ribbon-content">
        <p></p>
      </div>

    </div>
  </div>
  <div class="col-6 col-lg-3">
    <div class="card-box ribbon-box  ">
      <div class=" ribbon ribbon-info float-left">
        <span>Novos</span>
      </div>
      <div class="text-info float-right mt-0 total">
        {{resumoPedidos.novos | number}}
      </div>


      <div class="ribbon-content">
        <p></p>
      </div>

    </div>
  </div>
</div>

<div class="alert alert-success mb-2" role="alert" *ngIf="mensagemSucesso" (click)="fecheMensagemSucesso()">
  <i class="mdi mdi-check-all mr-2"></i> {{mensagemSucesso}} <i class="fa fa-print fa-lg ml-1 cpointer " (click)="imprimaPedido(this.novoPedido)" ></i>
</div>


<div class="filtro-info alert alert-info">
  <div class="row align-items-start filtro-pedidos__linha">
    <div class="col-auto">
      <kendo-formfield>
        <kendo-textbox placeholder="Busque por nome ou telefone do cliente ou por código"
                       name="txtFiltro" [(ngModel)]="objFiltro.q"
                       [clearButton]="true" style="width: 500px"
                       appAutoFocus (afterValueChanged)="onFilter($event)">
          <ng-template kendoTextBoxSuffixTemplate>
            <button kendoButton [look]="'clear'" [icon]="'search'" (click)="onFilter($event)"></button>
          </ng-template>
        </kendo-textbox>
      </kendo-formfield>
    </div>

    <div class="col-auto filtro-pedidos__status">
      <kendo-multiselect
        name="statusPedidos"
        [data]="statusPedidos"
        textField="descricao"
        valueField="valor"
        [valuePrimitive]="true"
        [autoClose]="false"
        placeholder="Todos os status"
        [(ngModel)]="objFiltro.statuses"
        (valueChange)="onFilter($event)">
      </kendo-multiselect>
    </div>

    <div class="col-auto filtro-pedidos__periodo">

      <div class="form-group ">

        <kendo-datepicker name="dia" id="dia" format="dd/MM/yyyy" class="form-control" placeholder="busque pelo dia"
                          #dia="ngModel"  [(ngModel)]="objFiltro.dia"  (valueChange)="alterouDia()" >

          <kendo-datepicker-messages
            today="Hoje"
            toggle="Trocar calendário"
          ></kendo-datepicker-messages>
        </kendo-datepicker>

      </div>

      <div class="filtro-pedidos__horarios" *ngIf="objFiltro.dia">
        <div class="form-group">
          <kendo-timepicker #trInicio="ngModel" [(ngModel)]="objFiltro.horaInicio" name="horaInicio" placeholder="hora início"
                            class="form-control" (valueChange)="alterouHorario()">

          </kendo-timepicker>
        </div>

        <div class="form-group">
          <kendo-timepicker #trFim="ngModel" [(ngModel)]="objFiltro.horaFim" name="horaFim" placeholder="hora fim"
               [min]="objFiltro.horaInicio" class="form-control" (valueChange)="alterouHorario()">

          </kendo-timepicker>
        </div>
      </div>
    </div>

    <div class="col-auto">
      <kendo-dropdownlist
        name="filtroImpressao"
        [data]="opcoesFiltroImpressao"
        textField="descricaoFiltro"
        valueField="id"
        [valuePrimitive]="true"
        [defaultItem]="{ id: null, descricaoFiltro: 'Todos os pedidos' }"
        [(ngModel)]="objFiltro.filtroImpressao"
        (ngModelChange)="alterouFiltroImpressao()"
        style="width: 250px">
      </kendo-dropdownlist>
    </div>

  </div>

   <p *ngIf="objFiltro.filtroData || objFiltro.statuses?.length || objFiltro.filtroImpressao != null">
     <span *ngIf="objFiltro.filtroData">
       Pedidos realizados/agendados no dia <b>{{objFiltro.dia | date: 'dd/MMM/yyyy'}}</b>

       <span *ngIf="objFiltro.horaInicio && objFiltro.horaFim">
        entre <b>{{objFiltro.horaInicio | date: 'HH:mm'}}</b> e <b>{{objFiltro.horaFim | date: 'HH:mm'}}</b></span>
     </span>

     <button class="btn btn-outline-secondary d-inline-block ml-2" (click)="limpeFiltros()">limpar filtro</button>
   </p>

</div>


<div class="clearfix mt-2"> </div>


<app-grid-pedidos #gridPedidos   [carregando]="carregando" [mesa]="mesa"></app-grid-pedidos>
<div class="clearfix mt-4"> </div>
